import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import Link from '@atlaskit/link';
import iconographyDo1 from "../../../../src/pages/foundations/iconography/iconography-legacy/_assets/iconography-01-do.png";
import iconographyDont1 from "../../../../src/pages/foundations/iconography/iconography-legacy/_assets/iconography-01-dont.png";
import iconographyDo2 from "../../../../src/pages/foundations/iconography/iconography-legacy/_assets/iconography-02-do.png";
import iconographyDont2 from "../../../../src/pages/foundations/iconography/iconography-legacy/_assets/iconography-02-dont.png";
import iconographyDo3 from "../../../../src/pages/foundations/iconography/iconography-legacy/_assets/iconography-03-do.png";
import iconographyDont3 from "../../../../src/pages/foundations/iconography/iconography-legacy/_assets/iconography-03-dont.png";
import * as React from 'react';
export default {
  SectionMessage,
  SectionMessageAction,
  Link,
  iconographyDo1,
  iconographyDont1,
  iconographyDo2,
  iconographyDont2,
  iconographyDo3,
  iconographyDont3,
  React
};